import { createContext } from 'react';
import { createTheme, themes } from '@chegg-ui/theme';
export var defaultContext = {
  envUrl: '/',
  dataTestPrefix: 'signed-in-footer'
};
/** Function to identify if a particular nav item is an instance of nav link item */

export var isNavLinkItem = function isNavLinkItem(navItem) {
  return 'href' in navItem;
};
export var FooterContext = /*#__PURE__*/createContext(defaultContext);
export var Footertheme = createTheme(themes.horizon);